'use client'

import { Fragment, JSX, useMemo, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid'

export default function FormSelector({
  labels,
  candidateForm,
  companyForm
}: {
  labels: any
  candidateForm: JSX.Element
  companyForm: JSX.Element
}) {
  const options = useMemo(
    () =>
      Object.keys(labels.OPTIONS).map((key) => ({
        id: labels.OPTIONS[key].ID,
        label: labels.OPTIONS[key].LABEL
      })),
    [labels.OPTIONS]
  )

  const [selected, setSelected] = useState(null)

  return (
    <section className="px-6 pb-24 sm:pb-32 lg:px-8 lg:py-48">
      <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-lg">
        <Listbox value={selected} onChange={setSelected}>
          <div className="relative mb-6">
            <label
              htmlFor="perfil"
              className="block text-sm font-medium leading-6"
            >
              {labels.LABEL}
            </label>
            <Listbox.Button
              className="mt-2.5 block h-10 w-full rounded-md border-0 bg-white px-3.5 py-2 text-left text-sm font-normal placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:leading-6"
              id="perfil"
            >
              <span className="block truncate">
                {options.find((option) => option.id === selected)?.label ||
                  labels.PLACEHOLDER}
              </span>
              <span className="pointer-events-none absolute inset-y-0 right-0 top-[34px] flex items-center pr-2">
                <ChevronDownIcon
                  className="h-5 w-5 text-brand-blue  transition-transform  ui-open:rotate-180 ui-open:transform"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>
            <Transition
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md  bg-white py-1 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                {options.map((option) => (
                  <Listbox.Option
                    key={option.id}
                    className={({ active }) =>
                      `relative h-10 cursor-default select-none py-2 pl-10 pr-4 text-brand-blue hover:cursor-pointer ${
                        active ? 'bg-brand-pink' : 'bg-white'
                      }`
                    }
                    value={option.id}
                  >
                    {({ selected }) => (
                      <>
                        <span
                          className={`block truncate ${
                            selected ? 'font-normal' : 'font-light'
                          }`}
                        >
                          {option.label}
                        </span>
                        {selected ? (
                          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-brand-blue">
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </Listbox>
        {selected === 'candidate' && candidateForm}
        {selected === 'company' && companyForm}
      </div>
    </section>
  )
}
